<div class="toast-stack">
    @for (toast of toasts(); track toast; let i = $index) {
        <div class="toast" @slideInOutRight role="alert">
            <span class="toast__icon" [ngClass]="toastService.toastBgClass(toast.type)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    @if (toast.type === ToastType.Error || toast.type === ToastType.Warning) {
                        <use href="#icon-exclamation" stroke-width="2.5" transform="scale(1.2)" transform-origin="center"></use>
                    }
                    @if (toast.type !== ToastType.Error && toast.type !== ToastType.Warning) {
                        <use href="#icon-check"></use>
                    }
                </svg>
            </span>
            <div class="toast__body">
                <div class="toast__title">{{ toastService.toastTitle(toast.type) }}</div>
                <div class="toast__detail">{{ toast.message }}</div>
                @if (toast.link) {
                    <a class="link-accent link-accent--block" (click)="toastService.goToLink(toast)">
                        {{ toast.linkString ? toast.linkString : 'View Results' }}
                    </a>
                }
            </div>
            <span class="toast__close" (click)="$event.stopPropagation(); toastService.removeToast(toast.id, true)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><use href="#icon-close"></use></svg>
            </span>
        </div>
    }
</div>
